<template>

  <Main v-if="loadjs" />

</template>

<script>
import {loadScript} from "./loadScript.js"
import {ref,reactive,provide} from 'vue'
import Main from './components/Main.vue'
export default {
  name: 'App',
  setup(){
      let loadjs=ref(false)
      let ztreq=reactive({
        data:{
          geturl:'',
          aurl:'',
          topurl:'',
          footurl:''
        }
      })
      provide('ztreq',ztreq)
      loadScript("https://www.zgfznews.com/libs/utils/ztrequest.js").then(()=>{
        loadjs.value=true;
        ztreq.data = window.ztreq
      })
      return{
        loadjs
      }
  },
  components: {
    Main,
  },

}
</script>
